module.exports = __webpack_public_path__ + "static/media/icon_sound.27990fba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_sound.svg
// module id = 86
// module chunks = 0